<template>
	<div class="rfmodel">
			<div class="buttonPanel p-2">
				<!-- <p class="m-0"> REFERRAL PROGRAM</p>
				<p class="m-0 refBtn"> 
				Refer your network to Alluraa - Get {{$root.currency()+$root.tofixed($root.REFER_AMOUNT, 0)}} <button type="button" class=" closeRemRe" v-b-modal="'referafriendpopup'">Refer a friend</button>
				</p>-->
				
				
				<b-row class="p-0 m-0">
					<b-col lg="8" md="8" sm="12" class="p-0">
					<p class="m-0"> REFERRAL PROGRAM</p>
						<p class="m-0 refBtn"> 
							Refer your network to Alluraa - Get {{$root.currency()+$root.tofixed($root.REFER_AMOUNT, 0)}} 
						</p>
					</b-col >
					<b-col lg="4" md="4" sm="12" class="p-0 text-center">
						
						
						  <p >&nbsp;</p>
						  <p class="m-0 refBtn"> 
						<button type="button" class=" closeRemRe" v-b-modal="'referafriendpopup'">Refer a friend</button>
						 </p>
						
					</b-col>
				</b-row>
				
				
			</div>
			<!--<b-modal id="setpassword" title="Change Password" ok-only @hidden="resetSelectedForm" >-->
			<b-modal id="referafriendpopup" title="Refer a friend"   ok-only    hide-footer no-close-on-backdrop size="md" centered >
			
				<template #modal-header>
				   
				  <div class="p-0 refHead">Referral Program Dashboard </div>
				 
				  <button type="button" aria-label="Close" @click="$bvModal.hide('referafriendpopup')" class="close">×</button>
				</template> <!--@click="$bvModal.hide('bv-modal-example')" -->
				
				<!--<div class="text-right"> <button type="button" aria-label="Close" class=" closeMe" @click="$bvModal.hide('promotionpopup')">×</button></div> -->
				<!--<div class="text-right"> <b-link  class="closeMerf" @click="$bvModal.hide('referafriendpopup'),remindmelater()">×</b-link></div> -->
				<b-row class="offerP22">
					<b-col >
							<p class="mb-2 text-xs text-center">Welcome to Alluraa's Referral Program! Here's how it Works:
							 </p> 
							<ul class="mb-4">
								<li>Use your unique referral code to share Alluraa with your network</li>
								<li>If a user signs up with your code, you get Rs. {{$root.REFER_AMOUNT}} in your Alluraa wallet</li>
								<li>Note that you must spend this amount within 7 days before it expires.</li>
								<li>Have questions? Reach out us at <b-link style="color: #007bff;">info@alluraa.com</b-link></li>
							
							</ul>
							
							<b-row class="m-0 mt-3 mb-4 refCode">
							<b-col lg="8">Your unique referral code: 
							 <div class="code text-red">{{ referralCode }}</div>
							 <input type="hidden" id="testing-code" v-model="referralCode">
							 </b-col>
							<b-col lg="4"> <span class="btn btn-info text-white copy-btn ml-auto btnCopy" @click.stop.prevent="copyTestingCode"> Copy code </span>					</b-col>
							
							</b-row>
							
							 <b-row class="mb-4">
							<b-col class="penSIg">
								<b-row class="m-0 mt-3 statusWall text-center">
								<b-col class="dividerR">
									<h2>{{signups}}</h2> 
									<span>SIGNUPS</span>
								</b-col>
								<b-col > 
									<h2>{{$root.currency()}}{{earned}}</h2> 
									<span>EARNED</span>
								</b-col>
								</b-row>
							</b-col>
							</b-row> 
							<p class="tandc"> By usign our Referral Program, you agree to our <b-link style="color: #007bff;">Referral Program Term & Conditions</b-link>  </p>
							
							
							<!-- <b-button  href="/register/sales-advisor" variant="danger" class="w-100 text-xs w-full  block rounded text-white visited:text-white bg-red-700 font-bold" @click="remindmelater()" >Register Now</b-button> -->
							
							
							
					</b-col>
				</b-row>
				
					
				
				
			  </b-modal>
			

	</div>		
</template>
<script>

/* setpassword
 
http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import '../assets/referafriendpopup.scss';

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  props: { 
	userData: { type: Array},	
  },
  mounted(){
    this.inLodcard();
	/*var roleIdmy =this.$root.customer_info.role;
	if(roleIdmy>0){
		this.myrole=roleIdmy;
		this.urlLink='/agent/my-shop';
	} */
  },
  computed: {
    
  },
  data() {
    return{
	  referralCode:'',
	  signups:0,
	  earned:0,
	  coform_password: '', 
      new_password: '', 
	  coform_passwordState: null, 
      new_passwordState:null, 
      passwordUrl: this.$root.WEBAPI+'webapi/passwordSet',
      urlprmoCoutUrl: this.$root.WEBAPI+'webapi/promotionCount',
      getreferalUrl: this.$root.WEBAPI+'webapi/getReferralDetails ',
		linkComments:'',
		iamiconfor:'',
		register: {
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
			urlLink:'/login',
			myrole:0,
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			//self.$session.set('remindmelater',1);
			//self.$bvModal.hide('referafriendpopup');
			
				self.axios.post(self.getreferalUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : self.$root.customer_info.user_id
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 //console.log(response.result.referer_id);
						 self.referralCode = response.data.result.referer_id;
						 self.signups = response.data.result.signups;
						 self.earned = response.data.result.earned;
						// console.log('count'); 
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		},
		remindmelater(){
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			self.$session.set('remindmelater',1);
			self.$bvModal.hide('referafriendpopup');
			
				self.axios.post(self.urlprmoCoutUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : self.$root.customer_info.user_id
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 
						 console.log('count'); 
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		},
		copyTestingCode () {
			var self =this;
			console.log(self.referralCode);
          let testingCodeToCopy = document.querySelector('#testing-code')
			testingCodeToCopy.setAttribute('type', 'text')   
          testingCodeToCopy.select();

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
			var messLi= 'Referral code was copied ' + msg;
			self.$bvToast.toast(messLi, {
					title: 'Unique referral code',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				});
			
          } catch (err) {
            alert('Oops, unable to copy');
          }

          /* unselect the range */
          testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
	
</style>
